import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { LinkVariant } from './enum';

import { classMap } from 'lit/directives/class-map.js';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { SvgUtilityInterface, SvgUtility } from '~/ui/utils/icons';
import { styles } from './link.styles';
import { DERElement } from '~/common/der-element';

export class Link extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) label?: string;

    @property({ type: String })
    variant?: LinkVariant = LinkVariant.Default;

    @property({ type: Boolean })
    disabled = false;

    @property({ type: String })
    svg?: keyof SvgUtilityInterface;

    @property({ type: String, attribute: 'svg-position' })
    svgPosition: 'before' | 'after' = 'before';

    @property({ type: String })
    url?: string;

    @property({ type: Boolean, attribute: 'wrap-text' })
    wrapText?: boolean = false;

    override render() {
        const content = html`
            ${this.svg && this.svgPosition === 'before'
                ? html`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                      ${SvgUtility[this.svg]}
                  </svg>`
                : ''}
            <span class="c-button__label"><slot>${this.label}</slot></span>
            ${this.svg && this.svgPosition === 'after'
                ? html`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                      ${SvgUtility[this.svg]}
                  </svg>`
                : ''}
        `;

        return this.url
            ? html`
                  <a
                      href="${this.url}"
                      class=${classMap({
                          'c-link': true,
                          'c-link__wrap-text': !!this.wrapText,
                          'variant-inverted': this.variant === LinkVariant.Inverted,
                      })}
                      >${content}</a
                  >
              `
            : html`
                  <button
                      .disabled=${this.disabled}
                      class=${classMap({
                          'c-link': true,
                          'c-link__wrap-text': !!this.wrapText,
                          'variant-inverted': this.variant === LinkVariant.Inverted,
                      })}
                      aria-label=${this.label || 'Link'}
                  >
                      ${content}
                  </button>
              `;
    }
}
